module.exports = __webpack_public_path__ + "static/media/boolean_operator_or.4f1f645f.svg";